import React from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import './Navbar.css';
import logo from '../assets/logo.png';
import ColorModeToggle from './ColorModeToggle';

const Navbar = ({ user, onLogin, onRegister, onLogout }) => {
  const location = useLocation();

  // Icons
  const Icons = {
    Home: () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>,
    Discover: () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"></polygon></svg>,
    Widgets: () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>,
    Guide: () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path></svg>,
    Profile: () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
  };

  return (
    <nav className="modern-navbar">
      {/* LEFT: Logo (Desktop Only) */}
      <div className="navbar-left">
        <Link to="/" className="nav-logo-link">
          <img src={logo} alt="Dagenda Logo" className="nav-logo-img" />
          <span className="logo-text">DAGENDAS</span>
        </Link>
      </div>

      {/* CENTER: Navigation Items (Desktop & Mobile) */}
      <div className="navbar-center">
        {/* Mobile Home */}
        <NavLink to="/" className="nav-item mobile-only" end>
          <span className="nav-icon"><Icons.Home /></span>
          <span className="nav-label">Ana Sayfa</span>
        </NavLink>

        {/* Desktop: Dagendalarım / Mobile: Hidden (uses Profile) */}
        <NavLink to="/profile" className="nav-item desktop-only">Dagendalarım</NavLink>

        <NavLink to="/community" className="nav-item">
          <span className="nav-icon mobile-only"><Icons.Discover /></span>
          <span className="nav-label">Keşfet</span>
        </NavLink>

        <NavLink to="/widgets" className="nav-item">
          <span className="nav-icon mobile-only"><Icons.Widgets /></span>
          <span className="nav-label">Widgetlar</span>
        </NavLink>

        <NavLink to="/rehber" className="nav-item">
          <span className="nav-icon mobile-only"><Icons.Guide /></span>
          <span className="nav-label">Rehber</span>
        </NavLink>

        {/* Mobile Profile */}
        <div className="nav-item mobile-only" onClick={user ? undefined : onLogin}>
          <NavLink to={user ? "/profile" : "#"} className={({ isActive }) => `mobile-nav-link ${isActive && user ? 'active' : ''}`}>
            <span className="nav-icon">
              {user?.photoURL ? (
                <img src={user.photoURL} alt="Profile" className="nav-mobile-avatar" />
              ) : (
                <Icons.Profile />
              )}
            </span>
            <span className="nav-label">{user ? 'Profil' : 'Giriş'}</span>
          </NavLink>
        </div>
      </div>

      {/* RIGHT: User Actions (Desktop Only) */}
      <div className="navbar-right">
        {/* Theme Toggle */}
        <ColorModeToggle />

        {user ? (
          <div className="user-profile-section">
            <Link to="/settings" className="nav-item settings-link" title="Ayarlar">
              ⚙️
            </Link>
            <Link to="/profile" className="user-pill">
              <img
                src={user.photoURL || "/avatar.png"}
                alt="Profil"
                className="nav-user-avatar"
              />
              <span className="nav-user-name">
                {user.displayName?.split(' ')[0] || "Profil"}
              </span>
            </Link>
            <button className="nav-logout-btn" onClick={onLogout}>
              Çıkış
            </button>
          </div>
        ) : (
          <div className="auth-buttons">
            <button className="nav-login-btn" onClick={onLogin}>
              Giriş Yap
            </button>
            <button className="nav-register-btn" onClick={onRegister}>
              Kayıt Ol
            </button>
          </div>
        )}
      </div>
    </nav >
  );
};

export default Navbar;